// extracted by mini-css-extract-plugin
module.exports = {"vehicleMassLoad":"styles_vehicleMassLoad__3VmOy","vehiclesForSales":"styles_vehiclesForSales__1WPhf","vehicleMassLoadBackButtom":"styles_vehicleMassLoadBackButtom__1WtEn"};